


























































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import Table from '@/components/Table/Index.vue';
import Pagination from '@/components/Pagination.vue';
import ToolMixin from '@/mixins/Tool.vue';
import StatementData from '@/data/StatementData';

@Component({
  components: {
    Table,
    Pagination,
  },
})
export default class StateView extends Mixins(ToolMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  TableHead = StatementData.TableHead;

  Breadcrumb = [
    {
      username: this.AuthInstance.user.username,
      role: this.AuthInstance.user.role,
    },
  ];

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  LoginName = '';
}
